/**
 * Felul predarii si plata, asa cum le vede clientul.
 *
 * Etichetele metodelor stau AICI, o singura data: checkout-ul, blocul de plata
 * din paginile pietei si urmarirea comenzii le numeau fiecare in felul lor.
 * O metoda pe care serverul o accepta si web-ul nu o poate numi nu se arata
 * (ADR-002: diferenta de versiune), deci tabela trebuie sa le cuprinda pe toate.
 */

import type { PaymentMethod, PickupPointDto } from "@deliveryapp/shared";

export const PAYMENT_METHOD_COPY: Record<PaymentMethod, { label: string; hint: string; card: boolean }> = {
  cash_on_delivery: {
    label: "Numerar la livrare",
    hint: "Plătești curierului, care îți predă bonul fiscal emis de restaurant.",
    card: false,
  },
  card_on_delivery: {
    label: "Plata cu cardul la livrare",
    hint: "Plătești cu cardul la ușă, pe terminalul restaurantului.",
    card: true,
  },
  cash_on_pickup: {
    label: "Numerar la ridicare",
    hint: "Plătești la restaurant, când iei comanda.",
    card: false,
  },
  card_on_pickup: {
    label: "Card la ridicare",
    hint: "Plătești cu cardul la restaurant, când iei comanda.",
    card: true,
  },
};

export function paymentMethodLabel(method: string): string | null {
  return method in PAYMENT_METHOD_COPY ? PAYMENT_METHOD_COPY[method as PaymentMethod].label : null;
}

/** Link catre harta, pentru drumul pana la locatia de ridicare. */
export function pickupMapsUrl(point: Pick<PickupPointDto, "lat" | "lng" | "name" | "address">): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${point.lat},${point.lng}`)}`;
}

/** Minutele pana la un moment ISO, rotunjite in sus, cel putin 1 (pentru „gata in ~N min"). */
export function minutesFromNow(iso: string, now: number = Date.now()): number {
  const minutes = Math.ceil((new Date(iso).getTime() - now) / 60_000);
  return Number.isFinite(minutes) ? Math.max(1, minutes) : 1;
}
